// extracted by mini-css-extract-plugin
module.exports = {"container":"_2jl4TGB","header":"_3JxRg35","content":"_ocYzfK3","block":"_kNAs6_c","title":"_21W7Xh4"};